import { useState, useEffect } from 'react';
import type { WindowDimensions } from '@/common/types/global.types';

function getInitialDimensions(): WindowDimensions {
  const rootDiv = document.getElementById('edma-root');
  if (rootDiv) {
    const rect = rootDiv.getBoundingClientRect();
    return { width: rect.width, height: rect.height };
  }
  return { width: window.innerWidth, height: window.innerHeight };
}

export function useRootDimensions() {
  const [dimensions, setDimensions] = useState<WindowDimensions>(getInitialDimensions);

  useEffect(() => {
    const rootDiv = document.getElementById('edma-root');
    if (!rootDiv) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect;
        setDimensions((prev) => {
          // Only update on height change (width changes from sidebar animation are irrelevant for maxHeight)
          if (prev.height === height) {
            return prev;
          }
          return { width, height };
        });
      }
    });

    resizeObserver.observe(rootDiv);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return dimensions;
}
